var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var StyledSmall = styled.small(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  line-height: 1.31;\n  color: ", ";\n"], ["\n  font-size: ", "px;\n  line-height: 1.31;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.typography.font.sizes.small;
}, function (_a) {
  var theme = _a.theme,
    color = _a["data-role"];
  return appearance(theme)(color);
});
var appearance = function (theme) {
  return function (variant) {
    switch (variant) {
      case 'secondary':
        {
          return theme.tokens.text.label.light;
        }
      case 'negative':
        {
          return theme.tokens.text.label.negative;
        }
      default:
        {
          return theme.tokens.text.label.regular;
        }
    }
  };
};
var templateObject_1;